export default [
    {
        name: 'Программист',
        income: 99000,
    },
    {
        name: 'Старший программист',
        income: 130000,
    },
    {
        name: 'Тим-лидер',
        income: 168000,
    },
    {
        name: 'Тестировщик',
        income: 75000,
    },
    {
        name: 'Старший тестировщик',
        income: 124000
    },
    {
        name: 'Дизайнер',
        income: 85000,
    },
    {
        name: 'Креативный директор',
        income: 120000,
    },
    {
        name: 'Управляющий проектами',
        income: 85000,
    },
    {
        name: 'Контент менеждер',
        income: 55000,
    }
]
